import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild,
} from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { NgbTypeahead } from '@ng-bootstrap/ng-bootstrap';
import { merge, Observable, Subject, Subscription } from 'rxjs';
import {
    debounceTime,
    distinctUntilChanged,
    filter,
    map,
} from 'rxjs/operators';
import { hasValidator } from '../_helpers/functions';

@Component({
    selector: 'sume-input-autocomplete',
    templateUrl: './autocomplete.component.html',
})
export class AutocompleteComponent implements OnInit, OnDestroy {
    @Input() label: string;
    @Input() controlName: string;
    @Input() formGroup: FormGroup;
    @Input() items: any;
    @Input() changeText = false;
    @Output() current = new EventEmitter<any>();

    @ViewChild('instance', { static: true }) instance: NgbTypeahead;
    focus$ = new Subject<string>();
    click$ = new Subject<string>();

    subscriptions: Subscription[] = [];
    isRequired: boolean;

    ngOnDestroy(): void {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }

    ngOnInit(): void {
        this.isRequired = hasValidator(
            this.formGroup.controls[this.controlName],
            'required'
        );
    }

    search = (text$: Observable<string>) => {
        this.subscriptions.push(
            text$.subscribe(res => {
                this.current.next(null);
            })
        );
        const debouncedText$ = text$.pipe(
            debounceTime(200),
            distinctUntilChanged()
        );
        const clicksWithClosedPopup$ = this.click$.pipe(
            filter(() => !this.instance.isPopupOpen())
        );
        const inputFocus$ = this.focus$;

        return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(
            map(term =>
                (term === ''
                    ? this.items
                    : this.items.filter(
                          v =>
                              v
                                  .normalize('NFD')
                                  .replace(/[^a-zA-Z0-9\s]/g, '')
                                  .toLowerCase()
                                  .indexOf(
                                      term
                                          .normalize('NFD')
                                          .replace(/[^a-zA-Z0-9\s]/g, '')
                                          .toLowerCase()
                                  ) > -1
                      )
                ).slice(0, 10)
            )
        );
    };

    onSelect(value) {
        this.current.next(value.item);
    }

    get formControl(): AbstractControl {
        return this.formGroup.get(this.controlName);
    }
}
